import { blockMemberGQLMutation, cancelEmailUpdateGQLMutation, deleteMemberGQLMutation, getMemberGQLQuery, getMembersGQLQuery, unblockMemberGQLMutation, updateMemberGQLQuery, } from '../../graphql/index.js';
export class MembersClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getMembersGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.members;
    }
    async get(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getMemberGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.member;
    }
    async update(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: updateMemberGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.updateMember;
    }
    async delete(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: deleteMemberGQLMutation(),
            variables,
            customToken: accessToken,
        });
        return result.deleteMember;
    }
    async cancelEmailUpdate(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: cancelEmailUpdateGQLMutation(),
            variables,
            customToken: accessToken,
        });
        return result.cancelEmailUpdate;
    }
    async blockMember(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: blockMemberGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.blockMember;
    }
    async unblockMember(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: unblockMemberGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.unblockMember;
    }
}
//# sourceMappingURL=members.client.js.map